import { useEffect, useState } from 'react';
import {
  todayStr,
  buildInitialUser,
  buildInitialProfessional,
  buildInitialStudent,
} from '../utils/formInitializers';
import { getRoleIdByName } from '../utils/formHelpers';

const Forms = (vm) => {
  const [acceptedPolicy, setAcceptedPolicy] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formDataUser, setFormDataUser] = useState(buildInitialUser(vm.userlogin));
  const [formDataProfesional, setFormDataProfesional] = useState(buildInitialProfessional());
  const [formDataEstudiante, setFormDataEstudiante] = useState(buildInitialStudent());
  const [formDataArea, setFormDataArea] = useState([]);

  useEffect(() => {
    const nextRole = vm.user
      ? vm.user?.FK_Role
       : vm.canAssignRole ? '' : getRoleIdByName(vm.roles, 'Usuario');
    setFormDataUser((prev) => ({
      ...prev,
      role: prev.role || nextRole || '',
    }));
  }, [vm.roles, vm.user, vm.canAssignRole]);


  const resetAll = () => {
    setFormDataUser({ ...buildInitialUser(null), birthdate: todayStr });
    setFormDataProfesional(buildInitialProfessional());
    setFormDataEstudiante(buildInitialStudent());
    setFormDataArea([]);
    setAcceptedPolicy(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      const id = value;
      setFormDataArea((prev) => {
        const list = Array.isArray(prev) ? prev : [];
        return checked
          ? list.includes(id)
            ? list
            : [...list, id]
          : list.filter((x) => x !== id);
      });
      return;
    }
    if (Object.hasOwn(formDataUser, name)) {
      setFormDataUser((prev) => ({
        ...prev,
        [name]: value,
        ...(name === 'country' ? { cityId: '' } : {}),
      }));
    }
    if (Object.hasOwn(formDataProfesional, name)) {
      setFormDataProfesional((prev) => ({ ...prev, [name]: value }));
    }
    if (Object.hasOwn(formDataEstudiante, name)) {
      setFormDataEstudiante((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validPolicy = async (e) => {
    const checked = e.target.checked;
    if (vm.mode === 'create') {
      setAcceptedPolicy(checked);
      return;
    }
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    setAcceptedPolicy(checked);
  };

  return {
    acceptedPolicy,
    setAcceptedPolicy,
    loading,
    setLoading,
    formDataUser,
    setFormDataUser,
    formDataProfesional,
    setFormDataProfesional,
    formDataEstudiante,
    setFormDataEstudiante,
    formDataArea,
    setFormDataArea,
    handleChange,
    validPolicy,
    resetAll,
  };
};

export default Forms;
